<template>
    <transition name="overlay">
        <div v-if="isCreatingJob" class="overlay" v-shortkey.once="['esc']" @shortkey="close">

            <header class="overlay__header overlay__header--absolute">
                <div class="overlay__container">
                    <span>Create new job in '{{ channel.name }}'</span>
                    <button @click="close" class="icon-button">
                        <icon type="close" color="white" size="18" />
                    </button>
                </div>
            </header>

            <section class="dialog">
                <div class="dialog__body">
                    <form @submit.prevent action="" method="post" class="lc-create-job-form form form--flex">
                        <div class="form__column w-full mr-0 md:w-2/3 md:mr-12">
                            <div class="form__group">
                                <label for="title" class="form__label">Title</label>
                                <span class="form__sublabel">Be as descriptive as you can</span>
                                <input ref="title" v-model="form.title" id="title" name="title" tabindex="1" class="lc-title form__input" autofocus autocomplete="off">
                                <p v-if="form.errors.has('title')" class="form__help form__help--error">{{ form.errors.get('title') }}</p>
                            </div>
                            <div class="lc-description form__group">
                                <label for="description" class="form__label">Description</label>
                                <editor id="description" v-model="form.description" tabindex="2" name="description" @cmd-enter="createJob" class="lc-description" />
                                <p v-if="form.errors.has('description')" class="form__help form__help--error">{{ form.errors.get('description') }}</p>
                            </div>
                        </div>
                        <div class="form__column w-full md:w-1/3">
                            <div class="form__group form__group--spaced">
                                <label for="column" class="form__label">Column</label>
                                <dropdown-menu id="column" ref="dropdown" inline-template>
                                    <div class="form__dropdown">
                                        <button @click.prevent="toggle" class="pill pill--column">
                                            <span class="pill__label w-full">{{ $parent.column.name }}</span>
                                            <icon type="chevron-bottom" color="gray" />
                                        </button>
                                        <ul v-if="open" class="dropdown-menu" role="menu" :aria-expanded="open">
                                            <li v-for="column in $parent.columns" :key="column.id" class="dropdown-menu__item">
                                                <a href="#" @click.prevent="$parent.updateColumn(column)" class="dropdown-menu__link">{{ column.name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </dropdown-menu>
                            </div>
                            <div class="form__group">
                                <label for="members" class="form__label">Notify users</label>
                                <span class="form__sublabel">Add the users you would like to notify about this job</span>
                                <members id="members" :users="activeMembers" v-model="form.members" />
                            </div>
                        </div>
                    </form>
                </div>
                <footer class="dialog__footer">
                    <button @click.prevent="createJob" tabindex="3" class="lc-submit button button--primary" :disabled="busy">Create job</button>
                </footer>
            </section>

        </div>
    </transition>
</template>

<script>
/* global app */
import { mapGetters, mapMutations, mapState } from 'vuex'
import Members from '../Global/Members'
import DropdownMenu from '../Global/DropdownMenu'
import Icon from '../Global/Icon.vue'
import Editor from '../Global/Editor'
import Form from '../../helpers/Form'
import { CLOSE_JOB_CREATION } from '../../stores/global/mutations'

export default {
    data () {
        return {
            visible: false,
            busy: false,
            form: new Form({
                title: '',
                description: '',
                column_id: null,
                members: [app.currentUser.id]
            })
        }
    },

    created () {
        this.form.column_id = this.columns[0].id
    },

    watch: {
        isCreatingJob (value) {
            if (value === true) {
                this.$nextTick(() => {
                    this.$refs.title.focus()
                })
            }
        }
    },

    methods: {
        ...mapMutations({
            close: CLOSE_JOB_CREATION
        }),

        createJob () {
            if (this.busy) {
                return
            }

            this.busy = true

            this.$store.dispatch('channel/createJob', this.form).then(() => {
                this.clearForm()
                this.close()
            }).finally(() => {
                this.busy = false
            })
        },

        clearForm () {
            this.form.title = ''
            this.form.description = ''
            this.form.column_id = this.columns[0].id
            this.form.members = [app.currentUser.id]
        },

        updateColumn (column) {
            this.form.column_id = column.id
            this.$refs.dropdown.close()
        }
    },

    computed: {
        ...mapState(['isCreatingJob']),
        ...mapState('channel', ['channel', 'columns']),
        ...mapGetters('channel', ['activeMembers']),

        column () {
            return this.channel.columns.find((column) => {
                return column.id === this.form.column_id
            })
        }
    },

    components: {
        Members,
        Editor,
        DropdownMenu,
        Icon
    }
}
</script>